import React, {
  FC
} from 'react';

import {
  CircleButton, type ButtonProps
} from 'src/shared/components';
import {
  themeColors
} from 'src/shared/utils/themeColors';
import {
  SearchIcon
} from 'src/shared/icons';

interface SearchButtonProps extends ButtonProps {
  iconColor?: string;
  borderColor?: string;
  iconSize?: string;
  size?: number;
  onClick: () => void;
}

export const SearchButton: FC<SearchButtonProps> = ({
  iconColor = themeColors['dim-gray'],
  borderColor = themeColors.gray90,
  iconSize = 24,
  size,
  onClick,
  ...props
}) => (
  <CircleButton
    size={size}
    borderColor={borderColor}
    onClick={onClick}
    {...props}
  >
    <SearchIcon
      color={iconColor}
      width={iconSize}
      height={iconSize}
    />
  </CircleButton>
);
